import { Directive, ElementRef, Input, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ResponsiveService } from '../services/responsive.service';

@Directive({
  selector: '[appResponsiveClass]',
  standalone: true
})
export class ResponsiveClassDirective implements OnInit, OnDestroy {
  @Input() appResponsiveClass: string = '';
  @Input() mobileClass: string = '';
  @Input() tabletClass: string = '';
  @Input() desktopClass: string = '';
  @Input() portraitClass: string = '';
  @Input() landscapeClass: string = '';

  private destroy$ = new Subject<void>();
  private currentClasses: string[] = [];

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private responsiveService: ResponsiveService
  ) {}

  ngOnInit(): void {
    this.responsiveService.screenSize$
      .pipe(takeUntil(this.destroy$))
      .subscribe(screenSize => {
        this.updateClasses(screenSize);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateClasses(screenSize: any): void {
    // Remove previous classes
    this.currentClasses.forEach(className => {
      if (className) {
        this.renderer.removeClass(this.elementRef.nativeElement, className);
      }
    });

    // Build new class list
    const newClasses: string[] = [];

    // Base class
    if (this.appResponsiveClass) {
      newClasses.push(this.appResponsiveClass);
    }

    // Screen size classes
    if (screenSize.isMobile && this.mobileClass) {
      newClasses.push(this.mobileClass);
    }
    if (screenSize.isTablet && this.tabletClass) {
      newClasses.push(this.tabletClass);
    }
    if (screenSize.isDesktop && this.desktopClass) {
      newClasses.push(this.desktopClass);
    }

    // Orientation classes
    if (screenSize.orientation === 'portrait' && this.portraitClass) {
      newClasses.push(this.portraitClass);
    }
    if (screenSize.orientation === 'landscape' && this.landscapeClass) {
      newClasses.push(this.landscapeClass);
    }

    // Apply new classes
    newClasses.forEach(className => {
      if (className) {
        this.renderer.addClass(this.elementRef.nativeElement, className);
      }
    });

    this.currentClasses = newClasses;
  }
}